import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {IvySpinnerColor, IvySpinnerSize} from '@crs/ivy';
import {TranslateService} from '@ngx-translate/core';

import {LoadingService} from '../../services/loading/loading.service';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class LoadingComponent implements OnInit {

	config?: {
		color: IvySpinnerColor,
		size: IvySpinnerSize,
		text: string,
	};


	constructor(public loadingService: LoadingService, private translate: TranslateService) {
		this.config = {
			color: 'default',
			size: 'lg',
			text: 'Loading'
		}
	}

	ngOnInit() {
	}


}
